// libs
import { styled } from '@nykaa/ui-components';

// constants
import { MAX_DWEB_WIDTH, MEDIA_BREAKPOINTS } from 'shared/styles/base';

export const FooterWrapper = styled.div`
  width: 100%;
  max-width: ${MAX_DWEB_WIDTH}px;
  margin: ${({ theme }) => `${theme.spacing.spacing160} auto`};
  padding: ${({ theme }) => `${theme.spacing.spacing200} 120px`};
  box-sizing: border-box;

  ${MEDIA_BREAKPOINTS.TILL_DESKTOP} {
    padding: ${({ theme }) => `${theme.spacing.spacing160} ${theme.spacing.spacing80}`};
  }
`;

export const FooterGrid = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing.spacing120};

  ${MEDIA_BREAKPOINTS.TILL_DESKTOP} {
    flex-direction: column;
  }
`;

export const CategorySection = styled.div`
  flex: 1;
  min-width: 0;
  word-break: break-word;

  & h1 {
    margin: ${({ theme }) => `${theme.spacing.spacing100} 0 ${theme.spacing.spacing50}`};
    ${({ theme }) => theme.typography.titleLarge};
  }

  & h2 {
    margin: ${({ theme }) => `${theme.spacing.spacing240} 0 ${theme.spacing.spacing50}`};
    ${({ theme }) => theme.typography.titleMedium};

    &:first-of-type {
      margin-top: 0;
    }
  }

  & h3 {
    margin: ${({ theme }) => `${theme.spacing.spacing100} 0 ${theme.spacing.spacing50}`};
    ${({ theme }) => theme.typography.titleSmall};
  }

  & p {
    margin-top: ${({ theme }) => theme.spacing.spacing50};
    ${({ theme }) => theme.typography.bodyMedium};
  }

  & a {
    color: ${({ theme }) => theme.colors.secondary};
  }

  & h1 span,
  & h2 span,
  & h3 span,
  & p span,
  & li span,
  & ol span,
  & ul span {
    color: ${({ theme }) => theme.colors.textPrimary} !important;
  }
`;

export const SideSection = styled.div`
  flex: 0 0 360px;
  width: 360px;
  max-width: 100%;

  ${MEDIA_BREAKPOINTS.TILL_DESKTOP} {
    flex: 1 1 auto;
    width: 100%;
  }
`;
